// Device capability check — used to serve a lighter (but complete) experience
// on low-RAM / low-core / data-saver devices.
export const isLowPower = () => {
  if (typeof navigator === "undefined") return false;
  const mem = navigator.deviceMemory || 8;
  const cores = navigator.hardwareConcurrency || 8;
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  return mem <= 4 || cores <= 4 || saveData;
};

// Slow-network check — 2G/3G or data-saver gets images only, no videos.
export const isSlowConnection = () => {
  const c = typeof navigator !== "undefined" ? navigator.connection : null;
  return Boolean(c && (c.saveData || c.effectiveType === "2g" || c.effectiveType === "3g"));
};


// Stricter gate for cheap cursor-only effects (transform-only gel press):
// 4-core devices handle these fine — only truly weak/data-saving devices skip.
export const isVeryLowPower = () => {
  if (typeof navigator === "undefined") return false;
  const mem = navigator.deviceMemory || 8;
  const cores = navigator.hardwareConcurrency || 8;
  const saveData = Boolean(navigator.connection && navigator.connection.saveData);
  return mem <= 3 || cores <= 2 || saveData;
};

// Routes may arrive with a trailing slash on hard loads (/phones -> /phones/).
export const routeKey = (pathname) => {
  const k = (pathname || "/").replace(/\/+$/, "");
  return k === "" ? "/" : k;
};
